import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSurvey } from '../survey';
import { formatCurrency } from '../common/utils';

const DISMISSED_AT_KEY = 'survey-notification-dismissed-at';
const DISMISS_DURATION_MS = 3 * 24 * 60 * 60 * 1000; // 3 Days

const isDismissed = () => {
    const dismissedAt = Number(localStorage.getItem(DISMISSED_AT_KEY));
    return Date.now() - dismissedAt < DISMISS_DURATION_MS;
};

const SurveyNotification = () => {
    const { surveys } = useSurvey();
    const navigate = useNavigate();
    const [dismissed, setDismissed] = useState(isDismissed);

    const dismiss = () => {
        localStorage.setItem(DISMISSED_AT_KEY, String(Date.now()));
        setDismissed(true);
    };

    return surveys.length > 0 && !dismissed ? (
        <section className="survey-notification" aria-label="New survey available">
            <span className="survey-notification-tag">New Survey</span>
            <span className="survey-notification-title" title={surveys[0].title}>{surveys[0].title}</span>
            <span className="survey-notification-reward">+{formatCurrency(surveys[0].rewardAmount)}</span>
            <button type="button" className="survey-notification-start" onClick={() => navigate('/surveys')}>
                Let's Go
            </button>
            <button type="button" className="survey-notification-dismiss" aria-label="Dismiss" onClick={dismiss}>✕</button>
        </section>
    ) : null;
};

export default SurveyNotification;